/**
 * Convert a filter object (neighborhood/uses/status/company/title) into an
 * ordered list of pill descriptors for display. Each pill has a `label`
 * and a `type` that maps to a BEM modifier (e.g.
 * `saved-searches-modal__filter-pill--neighborhood`).
 *
 * Used by both SavedSearchesModal (current-view filters) and
 * ExportDataModal (criteria preview).
 *
 * @param {object|null|undefined} filters
 * @returns {Array<{label: string, type: string}>}
 */
export function formatFilterPills(filters) {
  if (!filters) return [];

  const pills = [];

  if (filters.neighborhood?.length) {
    filters.neighborhood.forEach((n) => pills.push({ label: n, type: 'neighborhood' }));
  }
  if (filters.uses?.length) {
    filters.uses.forEach((u) => pills.push({ label: u, type: 'uses' }));
  }
  if (filters.status?.length) {
    filters.status.forEach((s) => pills.push({ label: s, type: 'status' }));
  }
  if (filters.company?.length) {
    filters.company.forEach((c) => pills.push({ label: c, type: 'company' }));
  }
  if (filters.title) {
    pills.push({ label: `"${filters.title}"`, type: 'title' });
  }

  return pills;
}

export default formatFilterPills;
